import { Divider, Grid, useMediaQuery } from '@mui/material';
import React, { useContext } from 'react'
import globalStyles from '../../../assets/styles/global.module.scss';
import headerStyles from '../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss';
import contactStyles from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import dividerStyles from '../../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss'
import IconsColor from '../../utility/iconsColor';
import GlobalButton from '../../utility/globalButton/button';
import GlobalPageHeaderText from '../../utility/globalPageHeaderText';
import { Outlet, useNavigate } from 'react-router-dom';
import { useVoiceAgentStore } from '../../../store/voiceAgentStore';
import { hasVoiceAgentManagePermission } from '../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../context/userContext';


const VoiceAgentGlobal = () => {
    const navigate = useNavigate();
    const { apiRoutesPermissionAssignment, userDetail } = useContext(UserContext) as UserContextPayload;

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const voiceAgentDetail = useVoiceAgentStore((state) => state.voiceAgentDetail)

    const isVoiceAgentListPage = () => {
        if (window.location.pathname == "/voiceagent") {
            return true
        }
        return false
    }

    const handleAddNewAgent = () => {
        navigate(`/voiceagent/createvoiceagent`)
    }

    const handlePageTitle = () => {
        if (isVoiceAgentListPage()) {
            return "Voice Agents"
        }
        else {
            if (window.location.pathname == "/voiceagent/createvoiceagent") {
                return voiceAgentDetail?.voice_agent_name ? "Update Voice Agent" : "Create Voice Agent"
            }
            if (window.location.pathname == "/voiceagent/createvoiceagent/customapi") {
                return "Custom API"
            }
            return "Voice Agent Deployments"
        }
    }

    return (
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
            <Grid
                container
                className={`${isVoiceAgentListPage() && contactStyles.contactPageHeaderContainer}`}
                direction={"column"}
                flexWrap={"nowrap"}
                padding={!isVoiceAgentListPage() ? "18px 0px" : ""}
            >
                <Grid item xs={12} sm={12}>
                    <Grid container className={globalStyles.alignItemCenter} direction={"column"}>
                        <Grid
                            item
                            className={`${contactStyles.fullwidth} ${contactStyles.contactPageHeaderInner}`}
                        >
                            <GlobalPageHeaderText
                                mainHeadText={handlePageTitle()}
                                flagMainTextOnly
                                actionBlock={
                                    (!(breakPoints.smallScreen)) &&
                                    <Grid container gap={2} justifyContent={breakPoints.flagTabletScreen ? "start" : "end"} flexWrap={"nowrap"}>
                                        <Grid item>
                                            <Grid container className={`${globalStyles.globalHeadMainItemRightContainer}`} gap="15px" justifyContent={{ lg: "end" }}>
                                                <Grid item>
                                                    {isVoiceAgentListPage() && hasVoiceAgentManagePermission(apiRoutesPermissionAssignment, userDetail) &&
                                                        <GlobalButton
                                                            className='primaryButtonStyle'
                                                            buttonText={"New Agent"}
                                                            startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor="#fff" />}
                                                            sx={{ width: "150px" }}
                                                            onClick={() => { handleAddNewAgent(); }}
                                                        />
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                }
                            />
                            {!(breakPoints.smallScreen) && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle} ${dividerStyles.customAPIPageDivider}`} />}
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={12} className={contactStyles.contactPageBody}>
                    <Outlet />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default VoiceAgentGlobal
